import { gql } from "@apollo/client"
import {
  SCHEDULE_LIST_FRAG,
  TRANSPORT_DETAIL_FRAG,
} from "./scheduling.fragments.gql"
// Queries
export const SCHEDULE_LIST = gql`
  query ScheduleList(
    $date: Date!
    $filter: ScheduleFilterInput
    $query: String
    $first: Int
    $skip: Int
  ) {
    schedulesForDate(
      date: $date
      filter: $filter
      query: $query
      first: $first
      skip: $skip
    ) {
      ...ScheduleListFrag
    }
  }
  ${SCHEDULE_LIST_FRAG}
`

export const SCHEDULES_FOR_PLOT = gql`
  query PlotSchedules($plotId: Int!) {
    schedulesForPlot(plotId: $plotId) {
      id
      date
      gatePass
      labourCount
      requiredQuantity
      aggregator {
        id
        fullName
      }
      plot {
        id
        name
        address {
          id
          village
        }
      }
      variety {
        id
        name
        commodity {
          id
          name
        }
      }
      vehicle {
        id
        registrationNumber
      }
    }
  }
`
export const SCHEDULE_TRANSPORT_DETAIL = gql`
  query ScheduleTransportDetail($schedule: Int!) {
    transportDetail(schedule: $schedule) {
      ...TransportDetailFrag
    }
  }
  ${TRANSPORT_DETAIL_FRAG}
`

export const HARVESTERS = gql`
  query AllAgregatorsSelector(
    $department: ID
    $date: Date!
    $first: Int
    $skip: Int
    $query: String
  ) {
    usersByGroup(
      groupName: "Aggregator"
      departmentId: $department
      status: "AV"
      first: $first
      skip: $skip
      query: $query
    ) {
      id
      number
      fullName
      schedulesForDate(date: $date) {
        id
        plotCommodity {
          id
          name
        }
      }
    }
  }
`
export const SCHEDULE_LIST_SUMMARY = gql`
  query ScheduleListSummary(
    $date: Date!
    $query: String
    $filter: ScheduleFilterInput
    $first: Int
    $skip: Int
  ) {
    schedulesForDateSummary(
      date: $date
      query: $query
      filter: $filter
      first: $first
      skip: $skip
    ) {
      plots
      labours
      count
      vehicles
      totalSkuCount
      totalUomQuantity
      aggregators
    }
  }
`
export const SCHEDULING_VEHICLES = gql`
  query ShedulingVehicles(
    $date: Date!
    $first: Int
    $skip: Int
    $query: String
  ) {
    allVehicles(first: $first, skip: $skip, query: $query) {
      id
      registrationNumber
      vehicleType {
        id
        category
        name
        capacity
        capacityUnit {
          id
          name
          codename
        }
      }
      schedulesForDate(date: $date) {
        id
        plotCommodity {
          id
          name
        }
      }
    }
  }
`
export const PRE_TRIP_GENERATE = gql`
  query PreTripGenerate($date: Date, $scheduleIds: [ID]) {
    preTripGenerate(date: $date, scheduleIds: $scheduleIds) {
      vehicleNo
      bookingCount
      suppliers {
        name
        village
        crop
        sku
        skuCount
      }
    }
  }
`
